var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeceptorBlockingImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#e7e6e6;}.c{fill:#8c94c9;}.d{fill:#97d3f1;}.e{opacity:0.995;}.f{fill:#0fb4d1;}.g{fill:#007da0;}.h{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.373 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33 -21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(56.15 88.221)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(47.443 36.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(42.611 64.432)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22 -14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(81.357 79.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(89.932 47.762)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(62.533 16.227)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-123.807 83.324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.526 -36.723)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1181.059,1124.784a1.441,1.441,0,0,0-2.038,0l-3.28,3.28-3.28-3.28a1.441,1.441,0,0,0-2.038,2.038l3.28,3.28-3.28,3.28a1.441,1.441,0,1,0,2.038,2.038l3.28-3.28,3.28,3.28a1.441,1.441,0,0,0,2.038-2.038l-3.28-3.28,3.28-3.28A1.441,1.441,0,0,0,1181.059,1124.784Z",
    transform: "translate(-1015.662 -1141.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1107.062,1075h-26.676a2.894,2.894,0,0,0-2.886,2.886v19.968a2.872,2.872,0,0,0,2.872,2.872h26.676a2.894,2.894,0,0,0,2.885-2.886v-19.967A2.88,2.88,0,0,0,1107.062,1075Zm-.024,19.9a1.635,1.635,0,0,1-1.635,1.635h-7.476a1.383,1.383,0,0,0-1.317.959.962.962,0,0,1-.915.667h-3.957a.961.961,0,0,1-.915-.667,1.384,1.384,0,0,0-1.317-.959h-7.469a1.646,1.646,0,0,1-1.641-1.641v-15.5a1.635,1.635,0,0,1,1.635-1.635H1105.4a1.646,1.646,0,0,1,1.641,1.641Z",
    transform: "translate(-934.026 -1097.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1163.578,1348.926h-3.552l-.7-2.841h-9.266l-.7,2.841H1145.8a1.246,1.246,0,0,0,0,2.492h17.775a1.246,1.246,0,1,0,0-2.492Z",
    transform: "translate(-995 -1341.889)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeceptorBlockingImage);
export default __webpack_public_path__ + "static/media/deceptorBlockingImage.283faa29abfa3584bc99fde0d077c5f4.svg";
export { ForwardRef as ReactComponent };